export default "__VITE_ASSET__f2da7b03__"